// Clave de idempotencia de una intención de cobro, guardada en `localStorage` con TTL.
// Extraída de `RebillChangePlanConfirm` (cambio de plan one-click) para reusarla en el plan de
// una marca (ADR-2026-10-28-elegir-plan-de-marca-2). Vive en `localStorage` y no en
// `sessionStorage` porque éste es POR PESTAÑA: reabrir el pago en otra pestaña arrancaría con
// una key nueva y el seguro no aplicaría. Quien llama define el scope en `storageKey`.

export function nuevaClaveDeIdempotencia(): string {
  const c = globalThis.crypto as Crypto | undefined;
  if (typeof c?.randomUUID === 'function') return c.randomUUID();
  // Fallback para contextos no seguros / navegadores viejos. No necesita ser
  // criptográfico: solo único por intención de cobro.
  return `cp-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

/** Reusa la key vigente de esta intención (más nueva que `ttlMs`) o crea una nueva. */
export function leerOCrearClaveDeIdempotencia(storageKey: string, ttlMs: number, ahora: number = Date.now()): string {
  try {
    const raw = localStorage.getItem(storageKey);
    if (raw) {
      const parsed = JSON.parse(raw) as { key?: unknown; ts?: unknown };
      if (typeof parsed?.key === 'string' && typeof parsed?.ts === 'number' && ahora - parsed.ts < ttlMs) {
        return parsed.key;
      }
    }
  } catch {
    // Storage bloqueado (Safari privado) o JSON corrupto → key nueva. Peor caso:
    // volvemos al comportamiento viejo, no rompemos nada.
  }
  const key = nuevaClaveDeIdempotencia();
  try {
    localStorage.setItem(storageKey, JSON.stringify({ key, ts: ahora }));
  } catch {
    // Sin storage la key vive solo para este intento (los reintentos de ESTA
    // llamada igual la comparten, que es donde más importa).
  }
  return key;
}

export function borrarClaveDeIdempotencia(storageKey: string): void {
  try {
    localStorage.removeItem(storageKey);
  } catch {
    /* nada que limpiar */
  }
}
